import { Component, ViewChild, TemplateRef, ElementRef, ViewContainerRef, OnInit, OnChanges, AfterViewInit, SimpleChanges, Input, HostListener } from '@angular/core';
import { fromEvent, debounceTime } from 'rxjs';
declare var google :any;

@Component({
  	selector: 'app-google-charts-scatter-chart',
  	templateUrl: './google-charts-scatter-chart.component.html',
  	styleUrls: ['./google-charts-scatter-chart.component.scss']
})

export class GoogleChartsScatterChartComponent implements OnInit, OnChanges, AfterViewInit {
	//@ViewChild('chartTemplate', { read: TemplateRef }) chartTemplateRef:TemplateRef<any>;

	@ViewChild("chartDiv", { static : false }) chartDivRef: ElementRef;
	@Input() chartData : any;
	@Input() chartOptions : any;
	chart : any;

  	constructor()
	{
		fromEvent(window, 'resize')
			.pipe(debounceTime(500))
			.subscribe(() => this.createChart());
	}		

    ngOnInit(): void {
		
    }

    ngAfterViewInit(): void {			
		//this.createChart();
    }

  	ngOnChanges(changes: SimpleChanges) {
		
		if(this.chartData && this.chartOptions) 
		{
			this.createChart();
		}			
	}	

	private createChart() : void {
		google.charts.load('current', {packages: ['corechart', 'scatter']});
		google.charts.setOnLoadCallback(() => {

            let responsiveChartOptions = { ... this.chartOptions}; 

			if(this.chartData && responsiveChartOptions) 
			{
				 this.chart = new google.visualization.ScatterChart(this.chartDivRef?.nativeElement);
				 this.chart.draw(this.chartData ?? [], responsiveChartOptions);		
			}
		});	
	}
}
